import React from 'react'
import classNames from 'classnames'
import { FormattedMessage, useIntl } from 'react-intl'

import { ImgSanity } from '@slite/components'

import { getCustomerQuotes } from '../../components/customerQuotes'
import { Section } from '../../components/Section'

export function SectionAiSearchTestimonials() {
  const intl = useIntl()
  const quotes = getCustomerQuotes(
    [
      'AndreFoekenNedapPerplexity',
      'AlexisDupontAgorapulseQuestions',
      'AlexisDupontAgorapulseMCP',
    ],
    intl
  )

  return (
    <Section
      containerVerticalPadding={120}
      background="moon-dust-lighter"
      className="position-relative"
    >
      <div
        className={classNames(
          'flexbox flexbox-column flexbox-align-center text-align-center',
          'margin-left-auto margin-right-auto'
        )}
        style={{ maxWidth: 800 }}
      >
        <h2
          className="font-family-title font-size-2 line-height-normal font-weight-medium shade-05"
          style={{ letterSpacing: '-0.02em' }}
        >
          <FormattedMessage
            id="aiSearch.testimonials.title"
            defaultMessage="Loved by teams who used to lose answers"
          />
        </h2>
      </div>

      <div
        className={classNames(
          'grid-12 grid-gap-24 margin-top-40',
          'margin-left-auto margin-right-auto'
        )}
        style={{ maxWidth: 1100 }}
      >
        {quotes.map((q) => (
          <div
            key={q.name + q.testimonial}
            className={classNames(
              'grid-span-4-large grid-span-6-medium grid-span-12-small',
              'background-shade-100 radius-larger padding-32 flexbox flexbox-column flexbox-gap-24'
            )}
            style={{ border: '1px solid var(--alpha-shade-40)' }}
          >
            <div className="font-size-4 line-height-large shade-05">
              {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
              “{q.testimonial}”
            </div>
            <div className="flexbox flexbox-align-center flexbox-gap-12 margin-top-auto">
              <ImgSanity
                src={q.pictureUrl}
                alt={q.name}
                width={44}
                className="radius-round"
              />
              <div>
                <div className="font-size-5 font-weight-semibold shade-05">
                  {q.name}
                </div>
                <div className="font-size-6 shade-30">{q.title}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </Section>
  )
}
